import { ReactElement } from 'react'
import styled from 'styled-components'

import { SITE_MAP_NAVIGATION } from '@/utils/enroutes'

import { ImageTitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { SiteMapLink } from '@/components/enlayouts/SiteMap/SiteMapLink'

export const SiteMapPage = () => {
  return (
    <SiteMapMain>
      <SiteMapLinks>
        {SITE_MAP_NAVIGATION.map(({ name, path, subdirectories }) => (
          <SiteMapLink
            key={name}
            name={name}
            path={path}
            subdirectories={subdirectories}
          ></SiteMapLink>
        ))}
      </SiteMapLinks>
    </SiteMapMain>
  )
}

SiteMapPage.getLayout = function getLayout(page: ReactElement) {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Site Map', path: '' },
  ]

  return (
    <>
      <Head title="Site Map " description="" noindex />
      <ImageTitleLayout
        title="Site Map"
        subTitle=""
        imgUrl="/images/top-sitemap.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const SiteMapMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 96px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    margin: 40px 0 70px;
    padding: 0 20px;
  }
`

const SiteMapLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 70px 80px;

  @media screen and (max-width: 1047px) {
    column-gap: 0px;
  }
`
